import IMask from 'imask';
import Swal from 'sweetalert2';
import tippy, { followCursor } from 'tippy.js';
import { Controller } from "stimulus";

import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

export default class extends Controller {
  static targets = [ 'emptyMessage', 'container' ];
  static values = { amount: Number };
  #keyType = {
    "phone": {
      "placeholder": "(11) 99999-9999",
      "type": "phone",
      "aria-label": "Telefone Cadastrado no PIX, Digite Somente números, máscara será aplicada",
      "inputmode": "tel",
      "maskOption": {
        mask: '(00) 00000-0000',
        dispatch: null
      }
    },
    "cnpj":  {
      "placeholder": "99.999.999/9999-99",
      "type": "text",
      "aria-label": "CNPJ Cadastrado no PIX, Digite Somente números, máscara será aplicada",
      "inputmode": "numeric",
      "maskOption": {
        "mask": "00.000.000/0000-00",
        dispatch: null
      }
    },
    "cpf":  {
      "placeholder": "222.222.222-22",
      "type": "text",
      "aria-label": "CPF Cadastrado no PIX, Digite Somente números, máscara será aplicada",
      "inputmode": "numeric",
      "maskOption": {
        "mask": "000.000.000-00",
        dispatch: null
      }
    },
    "email":  {
      "placeholder": "exemplo@exemplo.com.br",
      "type": "email",
      "aria-label": "EMAIL Cadastrado no PIX",
      "inputmode": "email"
    },
    "other": {
      "placeholder": "CHAVE-PIX-ALPHANUMERICA",
      "type": "text",
      "aria-label": "Chave Alphanúmerica Cadastrado no PIX",
      "inputmode": "text"
    }
  };

  connect() {
    this.element.querySelector('a.add-row').addEventListener('add-row:appended', (data) => {
      this.amountValue += 1;
      this.addEventListener(this.containerTarget.querySelector('.row.pix-key:last-child select.change-pix-type'));
      let elTippy = data.detail.row.querySelector('[data-tippy-content]');

      if (!!elTippy && !elTippy._tippy)
        tippy(elTippy, {
          allowHTML: true,
          animation: 'scale',
          interactive: true,
          followCursor: true,
          followCursor: 'horizontal',
          plugins: [followCursor],
          duration: [100, 0],
          delay: [500, 0],
          theme: 'traus-light',
          appendTo: document.body
        });
    });

    this.element.querySelectorAll('.row.pix-key select.change-pix-type').forEach(($el) => this.addEventListener($el));
  }

  remove(ev) {
    let $row = ev.currentTarget.closest('.row'),
      inputName = $row.dataset.objectName;
    this.askConfirmation().then((result) => {
      if (result.value) {
        this.containerTarget.insertAdjacentHTML('beforeend', `<input type="hidden" name="${inputName}[_destroy]" value="1" />`);
        $row.remove();
        this.amountValue -= 1;
        return;
      }
    })
  }

  askConfirmation() {
    return Swal.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-danger mx-2'
      },
      buttonsStyling: false,
      title: 'Atenção',
      html: "Deseja realmente <b>remover</b> essa chave PIX?",
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, tenho certeza'
    });
  }

  addEventListener($select) {
    let $pixKeyInput = $select.closest('.row').querySelector('.pix-key-input');

    $select.addEventListener('change', (ev) => {
      $pixKeyInput.value = "";
      this.applyMask($select, $pixKeyInput);
    });

    this.applyMask($select, $pixKeyInput);
  }

  amountValueChanged() {
    this.updateEmptyMessage();
  }

  updateEmptyMessage() {
    this.emptyMessageTarget.classList.toggle('hidden', this.amountValue > 0);
    this.containerTarget.classList.toggle('hidden', this.amountValue == 0);
  }

  applyMask(pixKeyType, pixKeyInput) {
    let attributes = this.#keyType[pixKeyType.value];

    if (window.current_mask_input) {
      window.current_mask_input.destroy();
    }

    pixKeyInput.setAttribute("placeholder", attributes["placeholder"]);
    pixKeyInput.setAttribute("type", attributes["type"]);
    pixKeyInput.setAttribute("aria-label", attributes["aria-label"]);
    pixKeyInput.setAttribute("inputmode", attributes["inputmode"]);
    pixKeyInput.focus();

    if (attributes["maskOption"]) {
      window.current_mask_input = IMask(pixKeyInput, attributes["maskOption"]);
    }
  }
}